import React, { useState, useEffect } from 'react'
import { injectIntl } from 'react-intl'
import { connect, useDispatch } from 'react-redux'
import { reduxForm, change } from 'redux-form'
import { compose } from 'recompose'
import { Grid, Typography, Button, useTheme } from '@material-ui/core'
import FormTextField from './FormTextField'
import { PhoneNumberField } from './PhoneNumberField'
import CalmButton from './CalmButton'
import { phoneNumber, required } from '../utilties/validators'
import { getUser } from '../utilties/userUtilities';
import { getPatient, requestPhoneVerificationCode, completePhoneVerification, resetPhoneVerificationCode, completeSignInPhoneVerification } from '../redux/actions'
import { isSavingSelector, verifyPhoneMaskSelector, patientSelector } from '../redux/selectors'
import { isMobile } from '../utilties/mobileDetector'

const formName = 'verifyPhoneNumber';

const AttachPhoneNumber = ({ intl, theme, isLoading, userDetails }) => {

    const dispatch = useDispatch();

    useEffect(() => {
        if (userDetails) {
            dispatch(change(formName, 'customPhoneNumber', userDetails.customPhoneNumber))
            dispatch(change(formName, 'customPhoneCountryCode', userDetails.customPhoneCountryCode))
        }
    }, [userDetails && userDetails.customPhoneNumber, userDetails && userDetails.customPhoneCountryCode])

    return [
        <Typography
            variant="body2"
            style={{
                //color: '#fff',
                margin: '30px 0',
                fontWeight: '300',
                fontSize: '17px',
                lineHeight: 'normal',
                letterSpacing: 'normal'
            }}
            align="justify"
        >
            {intl.formatMessage({ id: 'app.security.mfa.setup.message' })}
        </Typography>,
        userDetails && <PhoneNumberField
            label={intl.formatMessage({ id: 'app.phone' })}
            name='phoneNumber'
            phoneField='customPhoneNumber'
            phoneCountryCodeField='customPhoneCountryCode'
            validators={[phoneNumber]}
            val={userDetails.phoneNumber}
        />,
        <CalmButton
            style={{                
                minWidth: '231px',
                marginTop: '40px'
            }}
            type="submit"
            size="small"
            color="primary"
            variant="contained"
            disabled={isLoading}
        >
            {intl.formatMessage({ id: 'app.security.mfa.sendVerificationCode' })}
        </CalmButton>
    ];
}

const EnterCode = ({ intl, theme, isLoading, verifyPhoneMask, resetCode, fetchVerificationCode, autoFetch, userDetails, goBackButtonEnabled, resendHandler}) => {
    const COLOR_BLUE = theme.palette.secondary.A700

    const dispatch = useDispatch()

    useEffect(() => {
        if (autoFetch && userDetails && userDetails.customPhoneNumber)
            fetchVerificationCode(userDetails.customPhoneCountryCode, userDetails.customPhoneNumber);
    }, [])

    const [resendSecondsLeft, setResendSecondsLeft] = useState(0);

    useEffect(
        () => {

            const f = () => dispatch(function () {
                if (verifyPhoneMask && verifyPhoneMask.sentUtc) {
                    let seconds = Math.round(60 - (new Date() - new Date(verifyPhoneMask.sentUtc)) / 1000);

                    setResendSecondsLeft(seconds)
                }
            });

            f();

            let timer = setInterval(f, 1000)

            return () => {
                clearInterval(timer)
            }
        }
        , [verifyPhoneMask && verifyPhoneMask.sentUtc]
    )

    return (
        <React.Fragment>
            <Typography
                variant="body2"
                style={{
                    //color: '#fff',
                    margin: '30px 0',
                    fontWeight: '300',
                    fontSize: '17px',
                    lineHeight: 'normal',
                    letterSpacing: 'normal'
                }}
                align="center">
                {intl.formatMessage({ id: 'app.security.mfa.successfullySentMessage' })}:
             </Typography>
            <Typography
                variant="body2"
                style={{
                    //color: '#fff',
                    margin: '30px 0',
                    fontWeight: '300',
                    fontSize: '17px',
                    lineHeight: 'normal',
                    letterSpacing: 'normal'
                }}
                align="center">
                {verifyPhoneMask && verifyPhoneMask.mask}
            </Typography>
            <Typography
                variant="body2"
                style={{
                    //color: '#fff',
                    margin: '30px 0',
                    fontWeight: '300',
                    fontSize: '17px',
                    lineHeight: 'normal',
                    letterSpacing: 'normal'
                }}
                align="center">
                {intl.formatMessage({ id: 'app.security.mfa.enterCodeMessage' })}
            </Typography>
            <FormTextField
                label={intl.formatMessage({ id: 'app.security.mfa.verificationCodeLabel' })}
                fullWidth
                type="text"
                name="verificationCode"
                variant="filled"
                validators={[required]}
                align="center" />
            <Grid style={{ display: 'flex', flexWrap: 'wrap', width: '100%', justifyContent: 'space-around', marginTop: '20px' }}>
               { goBackButtonEnabled && 
                    <CalmButton
                        style={{
                            fontSize: '16px',
                            minWidth: isMobile ? 'unset' : '150px',
                        }}
                        variant="outlined"
                        disabled={isLoading}
                        color="secondary"
                        onClick={() => resetCode()}
                    >
                        {intl.formatMessage({ id: 'app.security.mfa.backButtonText' })}
                    </CalmButton>
                }
                <CalmButton
                    style={{
                        fontSize: '16px',
                        minWidth: isMobile ? 'unset' : '150px',
                    }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isLoading}
                >
                    {intl.formatMessage({ id: 'app.security.mfa.submitButtonText' })}
                </CalmButton>
            </Grid>
            {
                resendSecondsLeft <= 0
                    ? <CalmButton
                        style={{
                            fontSize: '16px',
                            minWidth: '180px',
                            margin: '30px auto 0'
                        }}
                        size="small"
                        variant="text"
                        disabled={isLoading}
                        color="primary"
                        onClick={() => resendHandler ? resendHandler() : fetchVerificationCode(verifyPhoneMask.phoneCountryCode, verifyPhoneMask.phoneNumber, true)}
                        align="center"
                    >
                        {intl.formatMessage({ id: 'app.security.mfa.resendButtonText' })}
                    </CalmButton>
                    : <Typography
                        variant="body2"
                        style={{
                            //color: '#fff',
                            marginTop: '30px',
                            fontWeight: '300',
                            fontSize: '16px',
                            lineHeight: 'normal',
                            letterSpacing: 'normal'
                        }}
                        align="center">
                        {intl.formatMessage({ id: 'app.security.mfa.resendPlaceHolder' }, { secondsLeft: resendSecondsLeft })}
                    </Typography>
            }
        </React.Fragment>
    )
}

const VerifyPhoneNumber = ({
    mode,
    intl,
    handleSubmit,
    userDetails,
    fetchUser,
    fetchVerificationCode,
    completeVerification,
    completeSignInVerification,
    resetCode,
    isLoading,
    verifyPhoneMask,
    returnUrl,
    resendHandler,
    onSuccessRedirectUrl
}) => {
    const theme = useTheme()

    const COLOR_BLUE = theme.palette.secondary.A700

    useEffect(() => {
        const user = getUser()

        if (user)
            fetchUser()
    }, [])

    //useEffect(() => {
       
    //}, [mode, verifyPhoneMask])

    const getFormSubmitHandler = (mode) => {
        switch (mode) {
            case 'attach':
            case 'verify':
                if (verifyPhoneMask)
                {
                    return (values) => completeVerification(values.verificationCode, onSuccessRedirectUrl);
                }
                else
                {
                    return (values) => fetchVerificationCode(values.customPhoneCountryCode, values.customPhoneNumber);
                }
            case 'verify-sign-in':
                return (values) => completeSignInVerification(values.verificationCode, returnUrl);
        }
    }

    const getView = (mode) => {
        switch (mode) {
            case 'attach':
                if (verifyPhoneMask) {
                    return (<EnterCode goBackButtonEnabled={true} intl={intl} theme={theme} userDetails={userDetails} isLoading={isLoading} fetchVerificationCode={fetchVerificationCode} completeVerification={completeVerification} verifyPhoneMask={verifyPhoneMask} resetCode={resetCode} />)
                }
                else {
                    return (<AttachPhoneNumber intl={intl} theme={theme} isLoading={isLoading} userDetails={userDetails} />);
                }
            case 'verify':
                return (<EnterCode autoFetch={true} intl={intl} theme={theme} userDetails={userDetails} isLoading={isLoading} fetchVerificationCode={fetchVerificationCode} completeVerification={completeVerification} verifyPhoneMask={verifyPhoneMask} resetCode={resetCode} />);
            case 'verify-sign-in':
                return (<EnterCode resendHandler={resendHandler} autoFetch={true} intl={intl} theme={theme} userDetails={userDetails} isLoading={isLoading} fetchVerificationCode={fetchVerificationCode} completeVerification={completeVerification} verifyPhoneMask={verifyPhoneMask} resetCode={resetCode} />);
                break;
        }
    }

    const getTitles = (mode) => {
        switch (mode) {
            case 'attach':
                return ['app.security.mfa.title.setup'];
            case 'verify':
                return ['app.security.mfa.title.verify'];
            case 'verify-sign-in':
                return ['app.security.mfa.title.verify'];
        }
    }

    return (
        <form data-testid="form-2-step-verification" onSubmit={handleSubmit(getFormSubmitHandler(mode))}>
            <Grid
                container
                direction="column"
                justify="flex-start"
                alignItems="center"
                style={{ width: '100%', margin: 'auto', color: 'black', padding: isMobile ? '2rem' : '4rem', }}
            >
                {
                    getTitles(mode).map((k, v) =>
                        <Grid item>
                            <Typography
                                variant="h3"
                                style={{
                                    textAlign: 'center',
                                    marginBottom: '11px',
                                    fontWeight: '500' 
                                }}
                                align="left"
                            >
                                {intl.formatMessage({ id: k })}
                            </Typography>
                        </Grid>
                    )
                }
                <Grid class="phone-input-light" item style={{ maxWidth: '400px', textAlign: 'center' }}>
                    {getView(mode)}
                </Grid>
            </Grid>
        </form>
    )
}

const mapStateToProps = (state) => ({
    isLoading: isSavingSelector(state),
    verifyPhoneMask: verifyPhoneMaskSelector(state),
    initialValues: patientSelector(state),
    userDetails: patientSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
    fetchUser: () => dispatch(getPatient()),
    fetchVerificationCode: (phoneCountryCode, phoneNumber, resend) => dispatch(requestPhoneVerificationCode(phoneCountryCode, phoneNumber, resend)),
    completeVerification: (code, onSuccessRedirectUrl) => dispatch(completePhoneVerification(code, onSuccessRedirectUrl)),
    completeSignInVerification: (code, mfaSign) => dispatch(completeSignInPhoneVerification(code, mfaSign)),
    resetCode: () => dispatch(resetPhoneVerificationCode())
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl,
    reduxForm({
        form: formName,
        touchOnChange: true,
        touchOnBlur: true
    }))

export default enhance(VerifyPhoneNumber)
